var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuIconPhoneLanding(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9166 14.5833V13.3333H7.91663L7.91663 14.5833H12.9166Z",
    fill: "#474350"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91663 8.33325L6.66663 8.33325L6.66663 13.3333H7.91663V8.33325Z",
    fill: "#474350"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9166 8.33325V7.08325L7.91663 7.08325V8.33325L12.9166 8.33325Z",
    fill: "#474350"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 8.33325L12.9166 8.33325V13.3333H14.1666V8.33325Z",
    fill: "#474350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 8.33325L15.4166 8.33325V13.3333H16.6666V8.33325Z",
    fill: "#474350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 8.33325V7.08325L16.6666 7.08325V8.33325L21.6666 8.33325Z",
    fill: "#474350"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 14.5833V13.3333H16.6666V14.5833H21.6666Z",
    fill: "#474350"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 8.33325L21.6666 8.33325V13.3333H22.9166V8.33325Z",
    fill: "#474350"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91663 17.0833H6.66663L6.66663 22.0833H7.91663V17.0833Z",
    fill: "#474350"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9166 17.0833V15.8333H7.91663V17.0833H12.9166Z",
    fill: "#474350"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9166 23.3333V22.0833H7.91663L7.91663 23.3333H12.9166Z",
    fill: "#474350"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 17.0833H12.9166V22.0833H14.1666V17.0833Z",
    fill: "#474350"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6666 17.0833H15.4166V22.0833H16.6666V17.0833Z",
    fill: "#474350"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 23.3333V22.0833H16.6666V23.3333H21.6666Z",
    fill: "#474350"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9166 17.0833H21.6666V22.0833H22.9166V17.0833Z",
    fill: "#474350"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6666 17.0833V15.8333H16.6666V17.0833H21.6666Z",
    fill: "#474350"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconPhoneLanding);
export default __webpack_public_path__ + "static/media/menu_icon_phone_landing.4fae19db9508f754c12729279e165453.svg";
export { ForwardRef as ReactComponent };